import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import AbstractBackground from "../components/AbstractBackground";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import LogoRedGama from '../Imagenes/Logos/LogoRedGama.jpg';
import LogoASC from '../Imagenes/Logos/LogoASC.png';
import LogoCameco from '../Imagenes/Logos/LogoCameco.png';
import LogoSadefi from '../Imagenes/Logos/LogoSadefi.png';
import LogoWinForge from '../Imagenes/Logos/LogoWinForge.png';
import LogoPanaderiaTeodelina from '../Imagenes/Logos/LogoPanaderiaTeodelina.png';
import LogoLavanderiaCorrientes from '../Imagenes/Logos/LogoLavanderiaCorrientes.png';
import LogoSolsticioCortinas from '../Imagenes/Logos/LogoSolsticioCortinas.png';
import LogoDeHospedajes from '../Imagenes/Logos/LogoDeHospedajes.jpg';
import LogoMiramarExpressLaundry from '../Imagenes/Logos/MiramarExpressLaundry.png';
import FotoKioscoMiramar1 from '../Imagenes/MiramarExpressLaundry/1.jpg';
import FotoKioskoMiramar2 from '../Imagenes/MiramarExpressLaundry/2.jpg';
import FotoKioscoMiramar3 from '../Imagenes/MiramarExpressLaundry/3.png';
import FotoKioscoMiramar4 from '../Imagenes/MiramarExpressLaundry/4.png';
import FotoKioscoMiramar5 from '../Imagenes/MiramarExpressLaundry/5.jpeg';
const Customers = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [fotoActiva, setFotoActiva] = useState(0);
  const sectionRef = useRef(null);
  const fotosProyecto = [{
    src: FotoKioscoMiramar1,
    alt: "Pantalla kiosko Miramar en local"
  }, {
    src: FotoKioskoMiramar2,
    alt: "Conexión de máquinas de lavado y secado"
  }, {
    src: FotoKioscoMiramar3,
    alt: "Captura de pantalla tótem Miramar 1"
  }, {
    src: FotoKioscoMiramar4,
    alt: "Captura de pantalla tótem Miramar 2"
  }, {
    src: FotoKioscoMiramar5,
    alt: "Pantalla kiosko Miramar con máquinas"
  }];
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.2
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  const clientes = [{
    id: 1,
    nombre: "RedGama",
    imagen: LogoRedGama
  }, {
    id: 2,
    nombre: "Panadería Teodelina",
    imagen: LogoPanaderiaTeodelina
  }, {
    id: 3,
    nombre: "Asociación Santafesina de Cultura",
    imagen: LogoASC
  }, {
    id: 4,
    nombre: "WinForge",
    imagen: LogoWinForge
  }, {
    id: 9,
    nombre: "Miramar Express Laundry",
    imagen: LogoMiramarExpressLaundry
  }, {
    id: 5,
    nombre: "CAMECO S.A",
    imagen: LogoCameco
  }, {
    id: 6,
    nombre: "Solsticio Cortinas",
    imagen: LogoSolsticioCortinas
  }, {
    id: 7,
    nombre: "DeHospedajes",
    imagen: LogoDeHospedajes
  }, {
    id: 8,
    nombre: "SADEFI",
    imagen: LogoSadefi
  }, {
    id: 10,
    nombre: "Lavandería Corrientes",
    imagen: LogoLavanderiaCorrientes
  }];
  const clientesDuplicados = [...clientes, ...clientes];
  return <div ref={sectionRef} id="clientes" className="relative bg-gradient-to-b from-[#0a0b0d] via-[#0e0f11] to-[#0a0b0d] pt-32 pb-40 overflow-hidden">
            {/* Línea decorativa superior */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#bdff57]/30 to-transparent" />

            {/* Fondo abstracto */}
            <AbstractBackground variant="circles" intensity="low" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: "easeOut"
      }} className="text-center mb-16">
                    <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium text-[#bdff57] border border-[#bdff57]/30 rounded-full bg-[#bdff57]/5">
                        Confían en nosotros
                    </span>
                    <h2 className="text-4xl sm:text-6xl lg:text-7xl font-normal tracking-tight text-white">
                        Empresas que{' '}
                        <span className="text-[#bdff57]">nos han elegido</span>
                    </h2>
                    <p className="mt-6 text-lg text-gray-400 max-w-2xl mx-auto">
                        Trabajamos con empresas de diversos rubros, ayudándoles a crecer con tecnología
                    </p>
                </motion.div>

                {/* Carrusel */}
                <motion.div initial={{
        opacity: 0
      }} animate={isVisible ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="relative">
                    {/* Gradientes de fade en los bordes */}
                    <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0b0d] to-transparent z-10 pointer-events-none" />
                    <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0b0d] to-transparent z-10 pointer-events-none" />

                    {/* Contenedor del carrusel */}
                    <div className="overflow-hidden py-8">
                        <div className="flex animate-infinite-scroll will-change-transform">
                            {clientesDuplicados.map((cliente, index) => <div key={`${cliente.id}-${index}`} className="flex-shrink-0 px-4">
                                    {/* Card con tamaño fijo */}
                                    <div className="group relative w-56 h-48 p-6 rounded-2xl bg-gradient-to-br from-[#1a1b1e]/50 to-[#141517]/50 border border-white/5 hover:border-[#bdff57]/20 transition-all duration-500 flex flex-col items-center justify-center">
                                        {/* Logo con contenedor de tamaño fijo */}
                                        <div className="flex items-center justify-center w-full h-24 mb-4">
                                            <img src={cliente.imagen} alt={cliente.nombre} className="max-h-16 max-w-[140px] w-auto h-auto object-contain rounded-lg filter grayscale group-hover:grayscale-0 transition-all duration-500" loading="lazy" />
                                        </div>

                                        {/* Nombre */}
                                        <div className="text-center h-12 flex items-center justify-center">
                                            <h3 className="text-white font-medium text-sm group-hover:text-[#bdff57] transition-colors duration-300 line-clamp-2">
                                                {cliente.nombre}
                                            </h3>
                                        </div>

                                        {/* Línea decorativa inferior */}
                                        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-16 h-0.5 bg-gradient-to-r from-transparent via-[#bdff57]/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                                    </div>
                                </div>)}
                        </div>

                    </div>
                </motion.div>

                {/* Caso de éxito destacado */}
                <motion.article initial={{
        opacity: 0,
        y: 40
      }} animate={isVisible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.55,
        ease: "easeOut"
      }} className="featured-project relative mt-20 overflow-hidden px-6 py-12 sm:px-10 lg:px-16 lg:py-16">
                    <div className="relative z-10 grid items-center gap-6 lg:grid-cols-[1.05fr_0.95fr] lg:gap-10">
                        <div>
                            <div className="mb-4 flex flex-wrap items-center gap-3">
                                <span className="inline-flex items-center gap-2 rounded-full border border-[#bdff57]/10 bg-[#bdff57]/10 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[#bdff57]">
                                    Proyecto reciente destacado 2026
                                </span>
                            </div>

                            <div className="mb-4 flex items-center gap-4">
                                    <img src={LogoMiramarExpressLaundry} alt="Logo de Miramar Express Laundry" className="h-16 w-16 max-h-full max-w-full object-contain" />
                                <div>
                                    <p className="text-sm text-gray-400">Lavandería automática</p>
                                    <h3 className="text-xl font-medium tracking-tight text-white sm:text-2xl">Miramar Express Laundry</h3>
                                </div>
                            </div>

                            <h4 className="max-w-xl text-2xl font-medium leading-tight tracking-tight text-white sm:text-3xl">
                                Nuevo caso de éxito: ecosistema digital para una franquicia de lavanderías automáticas.
                            </h4>
                            <p className="mt-6 max-w-xl text-sm leading-relaxed text-gray-400 sm:text-base">
                                Diseñamos el ecosistema digital de una franquicia de lavanderías automáticas: consiste en un kiosco de autogestión conectado con lavarropas y secarropas, que les permite a los usuarios elegir su servicio (lavado/secado) y abonar lo correspondiente. Además, les permite a los administradores controlar toda la operación desde un solo lugar (visualizar pedidos, controlar máquinas, observar estadísticas, y mucho más). El desarrollo incluyó el software de la pantalla y el panel administrador, así como la integración con el hardware de las máquinas y el sistema de pagos (tarjeta y posnet).
                            </p>

                        </div>
                        <div className="relative mx-auto w-full max-w-xl lg:ml-auto">
                            <div className="rounded-2xl border border-white/10 bg-[#111315] p-2 sm:p-3">
                                <div className="relative aspect-[3/5] md:aspect-[6/6] overflow-hidden rounded-xl border border-white/10 bg-black/20">
                                    {fotosProyecto[fotoActiva].src && <img src={fotosProyecto[fotoActiva].src} alt={fotosProyecto[fotoActiva].alt} loading="lazy" decoding="async" className="h-full w-full object-contain" />}
                                    <button type="button" onClick={() => setFotoActiva((fotoActiva - 1 + fotosProyecto.length) % fotosProyecto.length)} aria-label="Ver foto anterior" className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-white/10 bg-black/50 text-white transition-colors hover:border-[#bdff57]/50 hover:text-[#bdff57] sm:left-5 sm:h-11 sm:w-11">
                                        <FiChevronLeft aria-hidden="true" className="h-5 w-5" />
                                    </button>
                                    <button type="button" onClick={() => setFotoActiva((fotoActiva + 1) % fotosProyecto.length)} aria-label="Ver foto siguiente" className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-white/10 bg-black/50 text-white transition-colors hover:border-[#bdff57]/50 hover:text-[#bdff57] sm:right-5 sm:h-11 sm:w-11">
                                        <FiChevronRight aria-hidden="true" className="h-5 w-5" />
                                    </button>
                                </div>
                                <div className="flex items-center justify-between px-2 pt-3 sm:px-3 sm:pt-4">
                                    <span className="text-xs text-gray-500">0{fotoActiva + 1} <span className="text-gray-700">/ 0{fotosProyecto.length}</span></span>
                                    <div className="flex items-center gap-2" aria-label="Seleccionar foto">
                                        {fotosProyecto.map((foto, index) => <button key={foto.alt} type="button" onClick={() => setFotoActiva(index)} aria-label={`Ver imagen ${index + 1}`} aria-current={fotoActiva === index ? "true" : undefined} className={`h-2 rounded-full transition-all ${fotoActiva === index ? "w-6 bg-[#bdff57]" : "w-2 bg-white/25 hover:bg-white/50"}`} />)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.article>

            </div>

            {/* Estilos para la animación */}
            <style>
                {`
                    @keyframes infinite-scroll {
                        0% {
                            transform: translateX(0);
                        }
                        100% {
                            transform: translateX(-50%);
                        }
                    }

                    .animate-infinite-scroll {
                        display: flex;
                        width: max-content;
                        animation: infinite-scroll 30s linear infinite;
                    }

                    .animate-infinite-scroll:hover {
                        animation-play-state: paused;
                    }

                    @media (max-width: 640px) {
                        .animate-infinite-scroll {
                            animation-duration: 20s;
                        }
                    }
                    
                    .line-clamp-2 {
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }

                    .featured-project {
                        border-radius: 3rem 3rem 0 0;
                    }

                    .featured-project::before {
                        content: '';
                        position: absolute;
                        inset: 0;
                        border: 3px solid rgba(189, 255, 87, 0.55);
                        border-bottom: 0;
                        border-radius: inherit;
                        mask-image: linear-gradient(to bottom, black 0%, black 72%, transparent 100%);
                        -webkit-mask-image: linear-gradient(to bottom, black 0%, black 72%, transparent 100%);
                        pointer-events: none;
                    }

                    @media (max-width: 640px) {
                        .featured-project {
                            border-radius: 2rem 2rem 0 0;
                        }
                    }
                `}
            </style>
        </div>;
};
export default Customers;